exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-lg {\n  max-width: 800px; }\n\n.btn-orange {\n  background-color: #f78f03;\n  color: white; }\n  .btn-orange:hover {\n    background-color: #c57202; }\n\n.sk-three-bounce {\n  margin: 40px auto;\n  width: 80px;\n  text-align: center; }\n  .sk-three-bounce .sk-child {\n    width: 20px;\n    height: 20px;\n    background-color: #333;\n    border-radius: 100%;\n    display: inline-block;\n    animation: sk-three-bounce 1.4s ease-in-out 0s infinite both; }\n  .sk-three-bounce .sk-bounce1 {\n    animation-delay: -0.32s; }\n  .sk-three-bounce .sk-bounce2 {\n    animation-delay: -0.16s; }\n\n@keyframes sk-three-bounce {\n  0%, 80%, 100% {\n    transform: scale(0); }\n  40% {\n    transform: scale(1); } }\n\n.modal-body .touch-checkbox {\n  width: 25px !important;\n  height: 25px !important;\n  cursor: pointer; }\n\n.modal-body table th, .modal-body table td {\n  vertical-align: middle !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/rfid-laminate-modal/rfid-laminate-modal.component.scss
// module id = ../../../../../src/app/shared/modals/rfid-laminate-modal/rfid-laminate-modal.component.scss
// module chunks = main